import _ from 'underscore';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

import { CardSize } from '@bingads-webui-campaign-react/overview-card-const';
import {
  getResponsiveSize,
} from '@bingads-webui-campaign/fluent-page-data';
import { usePageStyles } from './style/styles';

const MediumSize = 768;
const LargeSize = 1200;

const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

const getStyleFromCardSize = (size, styles, containerWidth) => {
  if (size === CardSize.FullScreen) {
    return [styles.cardFull];
  }

  let styleClass = null;

  if (containerWidth > LargeSize) {
    styleClass = size === CardSize.Large ? styles.cardLarge : styles.cardSmall;
  } else if (containerWidth > MediumSize) {
    styleClass = size === CardSize.Large ? styles.cardFull : styles.cardMedium;
  } else {
    styleClass = styles.cardFull;
  }

  // For card that doesn't have full size large screen, we have to add a style to limit the height
  // so that all the cards on the same line have the same height
  return [styleClass, styles.column];
};

// This is only used by Pmax Overview page now
export function useOverviewWindowSizeChange(cardViewState, setCardViewState) {
  const styles = usePageStyles();
  const [responsiveSize, setResponsiveSize] = useState();

  const onWindowResize = useCallback(_.debounce(() => {
    const chartContainer = document.getElementsByClassName('ba-overview-page');
    const chartWidth = chartContainer[0].offsetWidth;
    let newCarViewState = [...cardViewState];

    newCarViewState = _.map(cardViewState, viewState => ({
      ...viewState,
      className: [viewState.id, ...getStyleFromCardSize(viewState.size, styles, chartWidth)],
    }));

    setCardViewState(newCarViewState);

    const content = document.querySelector('.app-shell-content');
    setResponsiveSize(getResponsiveSize(content.offsetWidth));
  }, 50, true), [cardViewState]);

  useEffect(() => {
    window.addEventListener('resize', onWindowResize, false);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [onWindowResize]);

  useLayoutEffect(() => {
    onWindowResize();
    // we call resize once when we load this component, to make sure card has correct size class
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return responsiveSize;
}

export function useOverviewPhase2WindowSizeChange() {
  const [responsiveSize, setResponsiveSize] = useState('');

  // Debounced resize handler
  const onShellContentResize = useCallback(
    debounce(() => {
      const content = document.querySelector('.app-shell-content');
      if (content) {
        setResponsiveSize(getResponsiveSize(content.offsetWidth));
      }
    }, 50),
    []
  );

  useEffect(() => {
    const content = document.querySelector('.app-shell-content');
    if (!content) {
      return;
    }

    const resizeObserver = new ResizeObserver(onShellContentResize);
    resizeObserver.observe(content);

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.disconnect();
    };
  }, [onShellContentResize]);

  useLayoutEffect(() => {
    const content = document.querySelector('.app-shell-content');
    if (content) {
      setResponsiveSize(getResponsiveSize(content.offsetWidth));
    }
  }, []);

  return responsiveSize;
}
